import React, { Fragment, useEffect } from 'react';
import c from 'classnames';

import { CoreLink } from '@uncinc/react-drupal-core';
import { Container } from '@uncinc/uncinc-react-kitchen-sink';

import WebshopProgressBar from './WebshopProgressBar';
import './style.scss';

interface StepsProgressBarProps {
  webShopCurrentPath?: string;
  currentStep: number;
  steps: Array<{ title: string; url?: string }>;
  checkIconForDone?: boolean;
  noIndexFirstAndLast?: boolean;
}

const StepsProgressBar: React.FC<StepsProgressBarProps> = ({
  webShopCurrentPath,
  currentStep,
  steps,
  checkIconForDone = false,
  noIndexFirstAndLast,
}) => {
  useEffect(() => {
    const activeStep = document.querySelector('.StepsProgressBar__step__current');
    if (activeStep) {
      activeStep.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }
  });

  return (
    <div className={c('StepsProgressBar', { StepsProgressBar__webshop: webShopCurrentPath })}>
      <Container>
        <div className="StepsProgressBar__inner">
          {webShopCurrentPath ? (
            // Webshop implementation based on current path.
            <WebshopProgressBar currentPath={webShopCurrentPath} />
          ) : (
            // Updated implementation based on steps array and current step.
            steps.map((step, index) => {
              const isFirstOrLast = index === 0 || index === steps.length - 1;
              const stepDone = currentStep > index;
              const stepCurrentOrDone = currentStep >= index;
              const isCurrentStep = currentStep === index;

              const classes = c({
                StepsProgressBar__step__number__done: stepCurrentOrDone,
                StepsProgressBar__step__number: !stepCurrentOrDone,
              });

              let circleContent;

              if (noIndexFirstAndLast) {
                // Option with no index in the first and last circle.
                circleContent = isFirstOrLast ? '\u00A0' : index;
              } else if (checkIconForDone) {
                // Option with classic counting and with "complete" icon for done elements.
                circleContent = stepDone ? <div className="icon icon-check icon-variant-2" /> : index + 1;
              } else {
                // Option with classic counting and not using "complete" icon in the done circles.
                circleContent = index + 1;
              }

              return (
                <Fragment key={step.title}>
                  <div className={c('StepsProgressBar__step', { StepsProgressBar__step__current: isCurrentStep })}>
                    <CoreLink href={step.url}>
                      <div className={classes}>
                        <span>{circleContent}</span>
                      </div>
                    </CoreLink>
                    <div className="StepsProgressBar__step__name">{step.title}</div>
                  </div>
                  {index < steps.length - 1 && <div className={c('StepsProgressBar__line', { StepsProgressBar__line__done: stepDone })} />}
                </Fragment>
              );
            })
          )}
        </div>
      </Container>
    </div>
  );
};

export default StepsProgressBar;
